// Buscador de Centros - Shopify Theme JavaScript

class BuscadorCentros {
    constructor() {
        this.map = null;
        this.markers = [];
        this.infoWindow = null;
        this.userLocation = null;
        this.clinicasWithDistance = [];
        this.geocoder = null;
        this.directionsService = null;
        this.directionsRenderer = null;
        this.settings = null;
        
        this.init();
    }

    init() {
        // Obtener configuración desde el DOM
        this.settings = window.buscadorSettings || {
            googleMapsApiKey: '',
            defaultZoom: 6,
            centerLat: 40.4168,
            centerLng: -3.7038
        };

        // Verificar que Google Maps esté cargado
        if (typeof google === 'undefined') {
            console.error('Google Maps API no está cargada');
            this.showMapError('Google Maps API no está disponible. Verifique su API Key.');
            return;
        }

        this.geocoder = new google.maps.Geocoder();
        this.directionsService = new google.maps.DirectionsService();
        this.directionsRenderer = new google.maps.DirectionsRenderer();
        
        this.initMap();
        this.loadClinics();
        this.setupEventListeners();
        this.getCurrentLocation();
    }

    showMapError(message) {
        const mapContainer = document.getElementById('map');
        if (mapContainer) {
            mapContainer.innerHTML = `
                <div style="display: flex; align-items: center; justify-content: center; height: 100%; color: #e74c3c; text-align: center; padding: 20px;">
                    <div>
                        <h3>⚠️ Error del Mapa</h3>
                        <p>${message}</p>
                        <small>Contacte al administrador para configurar Google Maps API</small>
                    </div>
                </div>
            `;
        }
    }

    initMap() {
        // Centro inicial configurable
        const center = { 
            lat: parseFloat(this.settings.centerLat) || 40.4168, 
            lng: parseFloat(this.settings.centerLng) || -3.7038 
        };
        
        try {
            this.map = new google.maps.Map(document.getElementById('map'), {
                zoom: parseInt(this.settings.defaultZoom) || 6,
                center: center,
                styles: [
                    {
                        featureType: 'poi',
                        elementType: 'labels',
                        stylers: [{ visibility: 'off' }]
                    }
                ],
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: true
            });

            this.infoWindow = new google.maps.InfoWindow();
            this.directionsRenderer.setMap(this.map);
        } catch (error) {
            console.error('Error inicializando el mapa:', error);
            this.showMapError('Error al cargar el mapa. Verifique la configuración de Google Maps.');
        }
    }

    loadClinics() {
        // Obtener datos de clínicas desde el DOM
        const clinicasData = window.clinicasData || { clinicas: [] };
        
        console.log('🔄 loadClinics() - Datos recibidos:', clinicasData);
        console.log('🔄 loadClinics() - Número de clínicas:', clinicasData.clinicas.length);
        
        this.clinicasWithDistance = clinicasData.clinicas.map(clinica => ({
            ...clinica,
            distance: null,
            distanceText: '',
            // Asegurar que las coordenadas sean números
            coordenadas: {
                latitud: parseFloat(clinica.coordenadas.latitud) || 40.4168,
                longitud: parseFloat(clinica.coordenadas.longitud) || -3.7038
            }
        }));
        
        this.renderClinicsList();
        if (this.map) {
            this.addMarkersToMap();
        }
    }

    renderClinicsList() {
        const container = document.getElementById('clinics-container');
        
        console.log('🎨 renderClinicsList() - Iniciando render');
        console.log('🎨 renderClinicsList() - Container encontrado:', !!container);
        console.log('🎨 renderClinicsList() - Clínicas disponibles:', this.clinicasWithDistance.length);
        console.log('🎨 renderClinicsList() - Datos de clínicas:', this.clinicasWithDistance);
        
        if (!container) {
            console.error('Container de clínicas no encontrado');
            return;
        }

        if (this.clinicasWithDistance.length === 0) {
            console.warn('⚠️ No hay clínicas para mostrar');
            container.innerHTML = '<div class="loading">No se encontraron clínicas configuradas</div>';
            return;
        }

        // Ordenar por distancia si está disponible
        const sortedClinics = [...this.clinicasWithDistance].sort((a, b) => {
            if (a.distance === null && b.distance === null) return 0;
            if (a.distance === null) return 1;
            if (b.distance === null) return -1;
            return a.distance - b.distance;
        });

        console.log('🎨 Clínicas ordenadas por distancia:', sortedClinics.map(c => ({
            nombre: c.nombre,
            distance: c.distance,
            distanceText: c.distanceText
        })));

        container.innerHTML = sortedClinics.map((clinica, index) => `
            <div class="clinic-item ${index === 0 && clinica.distance !== null ? 'closest' : ''}" data-index="${index}" data-id="${this.escapeHtml(clinica.nombre)}">
                <div class="clinic-toggle"></div>
                <div class="clinic-content">
                    <div class="clinic-name">${this.escapeHtml(clinica.nombre)}</div>
                    <div class="clinic-address">${this.escapeHtml(clinica.direccion)}</div>
                    ${clinica.distanceText ? `<div class="clinic-distance">${this.escapeHtml(clinica.distanceText)}</div>` : ''}
                    <div class="clinic-details">
                        ${clinica.telefono ? `
                            <div class="clinic-contact">
                                <div class="clinic-contact-icon">📞</div>
                                <span>${this.escapeHtml(clinica.telefono)}</span>
                            </div>
                        ` : ''}
                        ${clinica.email ? `
                            <div class="clinic-contact">
                                <div class="clinic-contact-icon">✉</div>
                                <span>${this.escapeHtml(clinica.email)}</span>
                            </div>
                        ` : ''}
                        ${clinica.sitio_web ? `
                            <div class="clinic-contact">
                                <div class="clinic-contact-icon">🌐</div>
                                <a href="${this.escapeHtml(this.formatWebsite(clinica.sitio_web))}" target="_blank" rel="noopener noreferrer" class="clinic-website">
                                    ${this.escapeHtml(clinica.sitio_web)}
                                </a>
                            </div>
                        ` : ''}
                        ${clinica.horario_especial ? `
                            <div class="clinic-contact">
                                <div class="clinic-contact-icon">🕒</div>
                                <span>${this.escapeHtml(clinica.horario_especial)}</span>
                            </div>
                        ` : ''}
                    </div>
                </div>
            </div>
        `).join('');

        this.setupClinicInteractions();
    }

    escapeHtml(text) {
        if (!text) return '';
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
        };
        return text.replace(/[&<>"']/g, function(m) { return map[m]; });
    }

    formatWebsite(website) {
        if (!website) return '';
        if (website.startsWith('http://') || website.startsWith('https://')) {
            return website;
        }
        return `https://${website}`;
    }

    setupClinicInteractions() {
        const clinicItems = document.querySelectorAll('.buscador-centros-wrapper .clinic-item');
        
        clinicItems.forEach((item, index) => {
            item.addEventListener('click', (e) => {
                // Toggle expansion
                item.classList.toggle('expanded');
                
                // Remove active class from all items
                clinicItems.forEach(i => i.classList.remove('active'));
                
                // Add active class to clicked item
                item.classList.add('active');
                
                // Center map on clinic
                const clinica = this.clinicasWithDistance[index];
                if (clinica && this.map) {
                    this.centerMapOnClinic(clinica);
                }
            });
        });
    }

    centerMapOnClinic(clinica) {
        if (!this.map) return;

        const position = {
            lat: clinica.coordenadas.latitud,
            lng: clinica.coordenadas.longitud
        };
        
        this.map.setCenter(position);
        this.map.setZoom(15);
        
        // Find and open info window for this marker
        const marker = this.markers.find(m => 
            Math.abs(m.getPosition().lat() - position.lat) < 0.0001 && 
            Math.abs(m.getPosition().lng() - position.lng) < 0.0001
        );
        
        if (marker) {
            this.openInfoWindow(marker, clinica);
        }
    }

    addMarkersToMap() {
        if (!this.map) return;

        // Clear existing markers
        this.markers.forEach(marker => marker.setMap(null));
        this.markers = [];

        this.clinicasWithDistance.forEach((clinica, index) => {
            const position = {
                lat: clinica.coordenadas.latitud,
                lng: clinica.coordenadas.longitud
            };

            const marker = new google.maps.Marker({
                position: position,
                map: this.map,
                title: clinica.nombre,
                animation: google.maps.Animation.DROP,
                icon: {
                    path: 'M 0,0 L 16,0 L 16,16 L 0,16 Z', // Cuadrado
                    scale: 1,
                    fillColor: '#000000',
                    fillOpacity: 1,
                    strokeWeight: 2,
                    strokeColor: '#ffffff',
                    anchor: new google.maps.Point(8, 8)
                }
            });

            marker.addListener('click', () => {
                this.openInfoWindow(marker, clinica);
                this.highlightClinicInList(clinica);
            });

            this.markers.push(marker);
        });

        // Adjust map bounds to show all markers
        if (this.markers.length > 0) {
            const bounds = new google.maps.LatLngBounds();
            this.markers.forEach(marker => bounds.extend(marker.getPosition()));
            this.map.fitBounds(bounds);
            
            // Ensure minimum zoom level
            const listener = google.maps.event.addListener(this.map, 'idle', () => {
                if (this.map.getZoom() > 16) this.map.setZoom(16);
                google.maps.event.removeListener(listener);
            });
        }
    }

    openInfoWindow(marker, clinica) {
        if (!this.infoWindow) return;

        const content = `
            <div style="max-width: 250px; font-family: Arial, sans-serif;">
                <h3 style="margin: 0 0 10px 0; color: #2c3e50; font-size: 16px;">${this.escapeHtml(clinica.nombre)}</h3>
                <p style="margin: 5px 0; color: #7f8c8d; font-size: 14px;">📍 ${this.escapeHtml(clinica.direccion)}</p>
                ${clinica.telefono ? `<p style="margin: 5px 0; color: #7f8c8d; font-size: 14px;">📞 ${this.escapeHtml(clinica.telefono)}</p>` : ''}
                ${clinica.distanceText ? `<p style="margin: 5px 0; color: #95a5a6; font-size: 12px; font-style: italic;">${this.escapeHtml(clinica.distanceText)}</p>` : ''}
                ${clinica.sitio_web ? `<p style="margin: 10px 0 0 0;"><a href="${this.escapeHtml(this.formatWebsite(clinica.sitio_web))}" target="_blank" rel="noopener noreferrer" style="color: #3498db; text-decoration: none; font-size: 14px;">Ver sitio web →</a></p>` : ''}
            </div>
        `;

        this.infoWindow.setContent(content);
        this.infoWindow.open(this.map, marker);
    }

    highlightClinicInList(clinica) {
        const clinicItems = document.querySelectorAll('.buscador-centros-wrapper .clinic-item');
        clinicItems.forEach(item => item.classList.remove('active'));
        
        const targetItem = Array.from(clinicItems).find(item => 
            item.dataset.id === clinica.nombre
        );
        
        if (targetItem) {
            targetItem.classList.add('active');
            targetItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    getCurrentLocation() {
        if (navigator.geolocation) {
            console.log('🗺️ Solicitando ubicación del usuario...');
            
            // Mostrar mensaje de carga
            const container = document.getElementById('clinics-container');
            if (container && this.clinicasWithDistance.length > 0) {
                const loadingDiv = document.createElement('div');
                loadingDiv.style.cssText = `
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    background: rgba(0,0,0,0.1);
                    color: #666;
                    padding: 10px;
                    text-align: center;
                    font-size: 12px;
                    border-bottom: 1px solid #e0e0e0;
                `;
                loadingDiv.textContent = '📍 Calculando distancias desde su ubicación...';
                loadingDiv.id = 'location-loading';
                container.parentElement.style.position = 'relative';
                container.parentElement.appendChild(loadingDiv);
            }
            
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    console.log('✅ Ubicación obtenida:', position.coords);
                    this.userLocation = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    
                    // Remover mensaje de carga
                    const loadingDiv = document.getElementById('location-loading');
                    if (loadingDiv) {
                        loadingDiv.remove();
                    }
                    
                    this.addUserMarker();
                    this.calculateDistances();
                },
                (error) => {
                    console.log('❌ Error obteniendo ubicación:', error);
                    
                    // Remover mensaje de carga
                    const loadingDiv = document.getElementById('location-loading');
                    if (loadingDiv) {
                        loadingDiv.remove();
                    }
                    
                    // Mostrar mensaje discreto
                    if (this.clinicasWithDistance.length > 0) {
                        console.log('💡 Tip: Comparte tu ubicación para ver distancias');
                    }
                },
                {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 60000
                }
            );
        } else {
            console.log('❌ Geolocalización no disponible en este navegador');
        }
    }

    calculateDistances() {
        if (!this.userLocation || !window.google) return;

        const service = new google.maps.DistanceMatrixService();
        
        // Dividir en lotes para evitar límites de API
        const batchSize = 10;
        const batches = [];
        
        for (let i = 0; i < this.clinicasWithDistance.length; i += batchSize) {
            batches.push(this.clinicasWithDistance.slice(i, i + batchSize));
        }

        let completedBatches = 0;
        
        batches.forEach((batch, batchIndex) => {
            const destinations = batch.map(clinica => ({
                lat: clinica.coordenadas.latitud,
                lng: clinica.coordenadas.longitud
            }));

            service.getDistanceMatrix({
                origins: [this.userLocation],
                destinations: destinations,
                travelMode: google.maps.TravelMode.DRIVING,
                avoidHighways: false,
                avoidTolls: false
            }, (response, status) => {
                if (status === google.maps.DistanceMatrixStatus.OK) {
                    const results = response.rows[0].elements;
                    
                    results.forEach((result, index) => {
                        if (result.status === 'OK') {
                            const clinicaIndex = batchIndex * batchSize + index;
                            if (this.clinicasWithDistance[clinicaIndex]) {
                                this.clinicasWithDistance[clinicaIndex].distance = result.distance.value;
                                this.clinicasWithDistance[clinicaIndex].distanceText = `${result.distance.text} desde su ubicación`;
                            }
                        }
                    });
                }
                
                completedBatches++;
                if (completedBatches === batches.length) {
                    this.renderClinicsList();
                }
            });
        });
    }

    searchLocation(query) {
        if (!query.trim() || !this.geocoder) return;

        this.geocoder.geocode({ address: query + ', España' }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK && results[0]) {
                const location = results[0].geometry.location;
                this.userLocation = {
                    lat: location.lat(),
                    lng: location.lng()
                };

                // Centrar mapa en la búsqueda
                if (this.map) {
                    this.map.setCenter(this.userLocation);
                    this.map.setZoom(12);
                }

                // Añadir marcador de usuario
                this.addUserMarker();

                // Recalcular distancias
                this.calculateDistances();
            } else {
                alert('No se pudo encontrar la ubicación. Intente con una dirección más específica.');
            }
        });
    }

    addUserMarker() {
        if (!this.userLocation || !this.map) return;

        // Remover marcador anterior si existe
        if (this.userMarker) {
            this.userMarker.setMap(null);
        }

        this.userMarker = new google.maps.Marker({
            position: this.userLocation,
            map: this.map,
            title: 'Su ubicación',
            icon: {
                path: 'M 0,0 L 20,0 L 20,20 L 0,20 Z', // Cuadrado más grande
                scale: 1,
                fillColor: '#666666',
                fillOpacity: 1,
                strokeWeight: 3,
                strokeColor: '#ffffff',
                anchor: new google.maps.Point(10, 10)
            }
        });
    }

    resetSearch() {
        // Limpiar campo de búsqueda
        const searchInput = document.getElementById('search-input');
        if (searchInput) {
            searchInput.value = '';
        }
        
        // Remover marcador de usuario
        if (this.userMarker) {
            this.userMarker.setMap(null);
            this.userMarker = null;
        }
        
        // Resetear ubicación de usuario
        this.userLocation = null;
        
        // Limpiar distancias
        this.clinicasWithDistance.forEach(clinica => {
            clinica.distance = null;
            clinica.distanceText = '';
        });
        
        // Volver a renderizar lista
        this.renderClinicsList();
        
        // Ajustar mapa para mostrar todas las clínicas
        if (this.map && this.markers.length > 0) {
            const bounds = new google.maps.LatLngBounds();
            this.markers.forEach(marker => bounds.extend(marker.getPosition()));
            this.map.fitBounds(bounds);
        }
        
        // Cerrar info window
        if (this.infoWindow) {
            this.infoWindow.close();
        }
    }

    setupEventListeners() {
        const searchInput = document.getElementById('search-input');
        const searchBtn = document.getElementById('search-btn');
        const resetBtn = document.getElementById('reset-btn');

        if (!searchInput || !searchBtn || !resetBtn) {
            console.error('Elementos de búsqueda no encontrados');
            return;
        }

        // Búsqueda
        searchBtn.addEventListener('click', () => {
            this.searchLocation(searchInput.value);
        });

        searchInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                this.searchLocation(searchInput.value);
            }
        });

        // Reset
        resetBtn.addEventListener('click', () => {
            this.resetSearch();
        });

        // Autocompletar direcciones (solo si Google Maps está disponible)
        if (window.google && google.maps.places) {
            try {
                const autocomplete = new google.maps.places.Autocomplete(searchInput, {
                    componentRestrictions: { country: ['es', 'pt'] },
                    types: ['geocode']
                });

                autocomplete.addListener('place_changed', () => {
                    const place = autocomplete.getPlace();
                    if (place.geometry) {
                        this.userLocation = {
                            lat: place.geometry.location.lat(),
                            lng: place.geometry.location.lng()
                        };
                        
                        if (this.map) {
                            this.map.setCenter(this.userLocation);
                            this.map.setZoom(12);
                        }
                        this.addUserMarker();
                        this.calculateDistances();
                    }
                });
            } catch (error) {
                console.log('Autocomplete no disponible:', error);
            }
        }
    }
}

// Función global para inicializar cuando Google Maps esté listo
window.initBuscadorCentros = function() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            new BuscadorCentros();
        });
    } else {
        new BuscadorCentros();
    }
};

// Inicializar inmediatamente si Google Maps ya está disponible
document.addEventListener('DOMContentLoaded', () => {
    // Verificar si existe el wrapper del buscador
    if (document.querySelector('.buscador-centros-wrapper')) {
        if (typeof google !== 'undefined') {
            new BuscadorCentros();
        } else {
            // Esperar un poco para Google Maps si no está cargado aún
            setTimeout(() => {
                if (typeof google !== 'undefined') {
                    new BuscadorCentros();
                } else {
                    console.log('Google Maps no está disponible. Verifica la configuración de la API Key.');
                }
            }, 1000);
        }
    }
});